import styled from 'styled-components'

export const StyledLogo = styled.span`
  display: block;
  font-family: cursive;
  cursor: pointer;
  font-size: 1.625rem;
  color: ${({ theme }) => theme.palette.text.secondary};
`
